import type {
	AdvertisersV1RegisterAdvertiserRequest,
	AffiliatesV1RegisterAffiliateRequest,
	UsersV1RegisterUserRequest,
} from '@sdk/Api'

export const registrationFormSettingsContextKey = 'registrationFormSettings'

export interface RegistrationForm {
	affiliate?: AffiliatesV1RegisterAffiliateRequest
	advertiser?: AdvertisersV1RegisterAdvertiserRequest
	user: UsersV1RegisterUserRequest
	acceptedTerms: boolean
}
